(function () {
    'use strict';

    angular
        .module('HRConfirmationsControllers')
        .controller('HRConfirmationsFacetsController', Controller);

    Controller.$inject = ['$scope', '$location', '$stateParams', '$translate', 'employeeSyncService'];

    function Controller($scope, $location, $stateParams, $translate, employeeSyncService) {

        // Load translations asynchronously to avoid race condition
        $translate('iam.hr.confirmations.facets.matchingRule').then(function(matchingRuleText) {
            $translate('iam.hr.confirmations.facets.exceptionRule').then(function(exceptionRuleText) {
                $translate('iam.hr.confirmations.facets.sourceId').then(function(sourceIdText) {

                    $scope.facets = [

                        // By Matching Rule
                        {
                            model: 'PubEmp_MatchingRuleName',
                            title: matchingRuleText,
                            groups: _.chain($scope.ctrlCtxt.matchingRules)
                                     .map(function (mRule) {
                                         var foundMatchings = _.filter($scope.allMatchingsAndExceptions, { PubEmp_MatchingRuleName: mRule.Name })

                                         return {
                                             count: foundMatchings.length,
                                             model: mRule.Name,
                                             facetModel: 'PubEmp_MatchingRuleName',
                                             facetTitle: matchingRuleText,
                                             title: mRule.Title,
                                             matchingRule: mRule
                                         };

                                     })
                                     .sortBy('title')
                                     .value()
                        },

                        // By Exception Rule
                        {
                            model: 'PubEmp_ExceptionRuleName',
                            title: exceptionRuleText,
                            groupTitleModels: ['ExceptionTitle'],
                            groups: []
                        },

                          // By Matricule
                        {
                            model: 'Matricule',
                            title: sourceIdText,
                            groupTitleModels: ['FirstName', 'LastName'],
                            groups: []
                        },

                    ];

                    setFacetGroups();
                    setSelectedFacetGroupFromUrlParams();
                    $scope.resetMatchingsAndExceptions();
                });
            });
        });

        // Show Facets Box?
        $scope.showFacetsBox = function () {
            var facetsWithGroups =
                _.filter($scope.facets, function (facet) {
                    return facet.groups.length;
                });

            if (facetsWithGroups.length === 0) return false;
            if (facetsWithGroups.length > 1) return true;

            return facetsWithGroups[0].groups.length > 1;
        };

        // Select Facet Group
        $scope.toggleFacetGroupSelection = function (facetGroup) {

            if ($scope.isFacetGroupSelected(facetGroup)) {
                $scope.clearFacetSelection();
                return;
            }

            $scope.ctrlCtxt.selectedFacetGroup = facetGroup;

            updateUrlRefineParams();
            $scope.resetMatchingsAndExceptions();
        };

        // Is Facet Group Selected?
        $scope.isFacetGroupSelected = function (facetGroup) {
            return facetGroup.model === $scope.ctrlCtxt.selectedFacetGroup.model;
        };

        // Show Facet Group?
        $scope.showFacetGroup = function (facetGroup) {
            if (!$scope.ctrlCtxt.selectedFacetGroup.model) return true;

            return $scope.isFacetGroupSelected(facetGroup);
        };

        // Is Facet Selected?
        $scope.isFacetSelected = function (facet) {
            return facet.model === $scope.ctrlCtxt.selectedFacetGroup.facetModel;
        };

        // Show Facet?
        $scope.showFacet = function (facet) {
            if (!facet.groups.length) return false;
            if (!$scope.ctrlCtxt.selectedFacetGroup.facetModel) return true;

            return facet.model === $scope.ctrlCtxt.selectedFacetGroup.facetModel;
        };

        // Clear Facet Selection
        $scope.clearFacetSelection = function () {
            $scope.ctrlCtxt.selectedFacetGroup = {};

            updateUrlRefineParams();
            $scope.resetMatchingsAndExceptions();
        };

        // Set Facet Groups
        function setFacetGroups() {
            $scope.facets = _.map($scope.facets, function (facet) {
                if (facet.groups.length > 0) return facet;

                facet.groups =
                    _.chain($scope.allMatchingsAndExceptions)
                     .filter(function (matchAndExce) { return matchAndExce[facet.model] })
                     .groupBy(facet.model)
                     .map(function (groupItems) {
                         var groupItemTitle =
                                 _.map(facet.groupTitleModels, function (tModel) {
                                     return groupItems[0][tModel];
                                 })
                                 .join(' ');

                         var matchingRuleName = groupItems[0][facet.model];

                         return {
                             count: groupItems.length,
                             model: matchingRuleName,
                             facetModel: facet.model,
                             facetTitle: facet.title,
                             title: groupItemTitle,
                             matchingRule: _.find($scope.ctrlCtxt.matchingRules, { Name: matchingRuleName })
                         }
                     })
                     .filter(function (group) { return group.count < $scope.allMatchingsAndExceptions.length })
                     .sortBy('title')
                     .value();

                return facet;
            });
        }

        // Set Selected Facet Group
        function setSelectedFacetGroupFromUrlParams() {
            if (_.isUndefined($stateParams.r) || _.isUndefined($stateParams.g)) {
                $scope.ctrlCtxt.selectedFacetGroup = {};
                updateUrlRefineParams();
            }

            var selectedFacetGroup =
                _.chain($scope.facets)
                  .filter({ model: $stateParams.r })
                  .map(function (facet) {
                      return facet.groups;
                  })
                  .flatten()
                  .find(function (group) {
                      return (group.model + '') === $stateParams.g;
                  })
                  .value();

            if (_.isUndefined(selectedFacetGroup)) {
                $scope.ctrlCtxt.selectedFacetGroup = {};
                updateUrlRefineParams();
                return;
            }

            $scope.ctrlCtxt.selectedFacetGroup = selectedFacetGroup;
        }

        function updateUrlRefineParams() {
            var refineFacetParam      = $scope.ctrlCtxt.selectedFacetGroup.facetModel ? $scope.ctrlCtxt.selectedFacetGroup.facetModel : undefined;
            var refineFacetGroupParam = $scope.ctrlCtxt.selectedFacetGroup.model ? $scope.ctrlCtxt.selectedFacetGroup.model : undefined;
            
            $location
                .search({
                    r: refineFacetParam,
                    g: refineFacetGroupParam
                })
                .replace();

            $stateParams.r = refineFacetParam;
            $stateParams.g = refineFacetGroupParam;
        };
    }
})();